import { useMemo } from 'react'

import { type FlatAllowanceCalculations } from 'components/hooks/quotes/useFlatAllowanceCalculations'
import { type QuoteResultCosts } from 'components/hooks/quotes/useQuoteResultCosts'
import { calculateTotalMonthlyPlatformFee } from 'pages/employer_onboarding/quote/quoteCalculations'
import { AllowanceStrategies, type AllowanceStrategy } from 'pages/employer_onboarding/quote/types'
import { type QuotingEmployee } from 'utils/web_api.schemas'

export function useQuoteCosts (
  willEnrollEmployees: QuotingEmployee[],
  flatAllowanceCosts: FlatAllowanceCalculations,
  dynamicAllowanceCosts: QuoteResultCosts,
  allowanceStrategy: AllowanceStrategy
) {
  const totalMonthlyPlatformFee = useMemo(() => {
    return calculateTotalMonthlyPlatformFee(willEnrollEmployees.length)
  }, [willEnrollEmployees.length])

  const {
    totalMonthlyEmployeeCost,
    totalMonthlyEmployerCost,
  } = useMemo(() => {
    if (allowanceStrategy === AllowanceStrategies.Flat) {
      return {
        totalMonthlyEmployeeCost: flatAllowanceCosts?.totalEmployeeCost ?? 0,
        totalMonthlyEmployerCost: flatAllowanceCosts?.totalEmployerCost ?? 0,
      }
    }
    return {
      totalMonthlyEmployeeCost: dynamicAllowanceCosts?.totalMonthlyEmployeeContribution ?? 0,
      totalMonthlyEmployerCost: dynamicAllowanceCosts?.totalMonthlyEmployerCost ?? 0,
    }
  }, [allowanceStrategy, flatAllowanceCosts, dynamicAllowanceCosts])

  const employerPortionOfInsurance = totalMonthlyEmployerCost
  const employeePortionOfInsurance = totalMonthlyEmployeeCost
  const totalEmployerCost = totalMonthlyEmployerCost + totalMonthlyPlatformFee

  return {
    totalMonthlyPlatformFee,
    employerPortionOfInsurance,
    employeePortionOfInsurance,
    totalEmployerCost,
  }
}
